module.exports = __webpack_public_path__ + "a6e7551a91ca0a924f108a4086d7e995.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/5.png
// module id = 541
// module chunks = 21 54 55 56 77 79 80 88